module.exports = __webpack_public_path__ + "static/media/DTA-2025-LOGO.d5a114a0.png";